<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputMarkets" });
import Chiplist from "../../../../elements/chip-list/ChipList.svelte";
import { MARKETS } from "../../config/market-codes.js";
import { t } from "svelte-i18n";
export let keys = [];
export let maxItems = void 0;
const getLabel = (markets, key) => {
    const MARKET = markets.find((market) => market.key === key);
    if (MARKET === void 0) {
        return key;
    }
    return $t(`global.${MARKET.type}.${MARKET.key}`);
};
$: items = Array.isArray(keys) ? keys.map((key) => ({ label: getLabel(MARKETS, key) })) : [];
</script>

{#if Array.isArray(items) && items.length > 0}
    <Chiplist { items } color = 'neutral' { maxItems }/>
{/if}